import { useState } from 'react';
import { TableCell, TableRow, Typography, Box, Button } from '@mui/material';
import AddFLCType40 from './AddFLCType40';
import { Dialog } from '../../style-guide';
import { useSelector, useDispatch } from 'react-redux';
import { addDesc } from '../Admins/AdminHandler'
import { deleteFLCType40 } from '../../reducers/requestHandler';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import { FaTrash, FaPen } from "react-icons/fa";

const FLCType40Row = ({ data }) => {
    const dispatch = useDispatch();
    const { roles, warehouseList } = useSelector(state => state.admin);
    const { admin } = useSelector(state => state.session);
    const { snackbar } = useSelector(state => state.snackbar);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = () => setOpenOrderModal(true);
    const onHandleCancelModal = () => setOpenOrderModal(false);
    const delFLCType40 = () => {

        var temp = {
            id: data.id,
            flcType40Id: data.id
        }
        deleteFLCType40(dispatch, snackbarToggle, temp, admin);

    };

    const [over, setOnOver] = useState(0);
    return (
        <TableRow sx={{ '& > *': { borderBottom: '1px solid gray', margin: 0, padding: '5px' } }}>
            <TableCell style={{ margin: 0, padding: '8px' }} />
            <TableCell style={{ margin: 0, padding: '8px' }} >
                <Typography variant='h7' >
                    {data.type || '-'}
                </Typography>
            </TableCell>
            <TableCell style={{ margin: 0, padding: '8px' }} />
            <TableCell style={{ margin: 0, padding: '8px' }} >
                <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Button sx={{ mr: 1 }} onClick={onHandleOpenModal} variant='outlined'>
                        <FaPen />
                    </Button>
                    <Button sx={{ mr: 1, background: (over == 0 ? '#F56C6C !important' : '#e5b6b6 !important'), color: 'white' }} onMouseOver={function () { setOnOver(1); }} onMouseLeave={function () { setOnOver(0); }} onClick={delFLCType40} variant='outlined'>
                        <FaTrash />
                    </Button>
                    {openOrderModal && (
                        <Dialog open={openOrderModal} title={'FLCType40'} onHandleCancel={onHandleCancelModal}>
                            <AddFLCType40 data={data} onHandleCancel={onHandleCancelModal} id={null} />
                        </Dialog>
                    )}
                </Box>
            </TableCell>
            <TableCell />
        </TableRow>
    );
};

export default FLCType40Row;
